"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCalculateableRolEchain = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const RolEchainUnion_1 = require("./RolEchainUnion");
const isCalculateableRolEchain = (whatever) => (0, RolEchainUnion_1.isRolEchainUnionUnsafe)(whatever) &&
    (0, echain_shared_modelling_1.isWithRequired)(whatever, {
        Verfahrweg: true,
        Versatz: true,
    });
exports.isCalculateableRolEchain = isCalculateableRolEchain;
//# sourceMappingURL=CalculateableRolEchain.js.map